<template>
    <img :src="imageSource" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import HistoryIcon from '@/assets/images/experiences/icons/ex-pin-history.svg';
import BeachesIcon from '@/assets/images/experiences/icons/ex-pin-beaches.svg';
import FoodIcon from '@/assets/images/experiences/icons/ex-pin-food-drink.svg';
import ArtsIcon from '@/assets/images/experiences/icons/ex-pin-arts-culture.svg';
import CivilRightsIcon from '@/assets/images/experiences/icons/ex-pin-civil-rights-legacy.svg';
import MusicIcon from '@/assets/images/experiences/icons/ex-pin-music.svg';
import GolfIcon from '@/assets/images/experiences/icons/ex-pin-year-round-golf.svg';
import OutdoorsIcon from '@/assets/images/experiences/icons/ex-pin-outdoors.svg';
import ScienceIcon from '@/assets/images/experiences/icons/ex-pin-science-exploration.svg';
import SportsIcon from '@/assets/images/experiences/icons/ex-pin-sports.svg';

@Component({})
class EventIcon extends Vue {
    @Prop({
      type: Array,
      required: true,
    })
    eventTypeIds;

    get imageSource() {
      if (this.eventTypeIds.length === 0) {
        return SportsIcon;
      }
      switch (this.eventTypeIds[0]) {
        case 1:
          return HistoryIcon;
        case 2:
          return BeachesIcon;
        case 3:
          return FoodIcon;
        case 4:
          return ArtsIcon;
        case 5:
          return CivilRightsIcon;
        case 6:
          return MusicIcon;
        case 7:
          return GolfIcon;
        case 8:
          return OutdoorsIcon;
        case 9:
          return ScienceIcon;
        case 10:
        default:
          return SportsIcon;
      }
    }
}

export default EventIcon;
</script>

<style>

</style>
